import axios from 'axios';
import { apiUrl } from '../schema/Environment';

const apiClient = axios.create({
    baseURL: apiUrl,
    timeout: 30000,
});

// Request interceptor - добавляет токены к каждому запросу
apiClient.interceptors.request.use(
    (config) => {
        // Загрузка файлов (multipart) может идти дольше 30с — общий timeout не применяем.
        if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
            config.timeout = 0;
        }
        const accessToken = sessionStorage.getItem('token');
        const refreshToken = sessionStorage.getItem('refreshToken');

        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        if (refreshToken) {
            config.headers['X-Refresh-Token'] = refreshToken;
        }

        // Добавляем X-Camp-Code для всех запросов (Gateway преобразует в X-Camp-Id)
        try {
            const campData = sessionStorage.getItem('camp');
            if (campData) {
                const { campCode } = JSON.parse(campData);
                if (campCode) {
                    config.headers['X-Camp-Code'] = campCode;
                }
            }
        } catch {
            // ignore
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor - ловит новые токены от Gateway
apiClient.interceptors.response.use(
    (response) => {
        // Проверяем headers на новые токены (auto-refresh от Gateway)
        const newAccessToken = response.headers['x-new-access-token'];
        const newRefreshToken = response.headers['x-new-refresh-token'];

        if (newAccessToken) {
            sessionStorage.setItem('token', newAccessToken);
        }
        if (newRefreshToken) {
            sessionStorage.setItem('refreshToken', newRefreshToken);
        }

        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            const isPublicEndpoint = error.config?.url?.includes('/public/');
            if (!isPublicEndpoint && sessionStorage.getItem('token')) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                sessionStorage.removeItem('refreshToken');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
